export default {
    COM_DISPUTA: 'Com Disputa', SEM_DISPUTA: 'Sem Disputa'
}
